module.exports = __webpack_public_path__ + "static/img/icon_goal.8578830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/icon_goal.png
// module id = 652
// module chunks = 2